import * as React from 'react';

import './styles.scss';

export interface IFormRowGroupProps {
}

interface IState {
}

/**
 * Groups multiple form row items to single line
 */
export default class FormRowGroup extends React.Component<IFormRowGroupProps, IState> {
    static displayName: string = 'FormRowGroup';

    constructor (props: IFormRowGroupProps) {
        super(props);
    }

    render () {
        return (
            <div className="form-row-group">
                {React.Children.map(this.props.children, (child) => {
                    if (React.isValidElement(child) && typeof child.type === 'function') {
                        // @ts-ignore
                        if (child.type.displayName === 'Button' || child.type.displayName === 'ButtonIcon' || child.type.displayName === 'Dropzone') {
                            return (
                                <div className="form-row-group-item form-row-group-button">
                                    {child}
                                </div>
                            );
                        }
                        let c = 'form-row-group-item';

                        if (child.props && child.props.size) {
                            c = c + ' ' + child.props.size;
                        }

                        return (
                            <div className={c}>
                                {child}
                            </div>
                        );
                    } else {
                        return child;
                    }
                })}
            </div>
        );
    }
}
